// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/cloud_config.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_utils_v1_sensitive } from "../../utils/v1/sensitive_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/cloud_config.proto.
 */
export const file_chalk_server_v1_cloud_config: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_utils_v1_sensitive]);

/**
 * @generated from message chalk.server.v1.AWSCloudWatchConfig
 */
export type AWSCloudWatchConfig = Message<"chalk.server.v1.AWSCloudWatchConfig"> & {
  /**
   * @generated from field: optional string log_group_path = 1;
   */
  logGroupPath?: string;

  /**
   * @generated from field: repeated string log_group_paths = 2;
   */
  logGroupPaths: string[];
};

/**
 * Describes the message chalk.server.v1.AWSCloudWatchConfig.
 * Use `create(AWSCloudWatchConfigSchema)` to create a new message.
 */
export const AWSCloudWatchConfigSchema: GenMessage<AWSCloudWatchConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_cloud_config, 0);

/**
 * @generated from message chalk.server.v1.AWSSecretManagerConfig
 */
export type AWSSecretManagerConfig = Message<"chalk.server.v1.AWSSecretManagerConfig"> & {
  /**
   * @generated from field: optional string secret_kms_arn = 1;
   */
  secretKmsArn?: string;

  /**
   * @generated from field: map<string, string> secret_tags = 2;
   */
  secretTags: { [key: string]: string };

  /**
   * @generated from field: optional string secret_prefix = 3;
   */
  secretPrefix?: string;
};

/**
 * Describes the message chalk.server.v1.AWSSecretManagerConfig.
 * Use `create(AWSSecretManagerConfigSchema)` to create a new message.
 */
export const AWSSecretManagerConfigSchema: GenMessage<AWSSecretManagerConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_cloud_config, 1);

/**
 * @generated from message chalk.server.v1.GCPSecretReplicationReplica
 */
export type GCPSecretReplicationReplica = Message<"chalk.server.v1.GCPSecretReplicationReplica"> & {
  /**
   * @generated from field: string location = 1;
   */
  location: string;
};

/**
 * Describes the message chalk.server.v1.GCPSecretReplicationReplica.
 * Use `create(GCPSecretReplicationReplicaSchema)` to create a new message.
 */
export const GCPSecretReplicationReplicaSchema: GenMessage<GCPSecretReplicationReplica> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_cloud_config, 2);

/**
 * @generated from message chalk.server.v1.GCPRegionConfig
 */
export type GCPRegionConfig = Message<"chalk.server.v1.GCPRegionConfig"> & {
  /**
   * Valid values currently, string for readability:
   * GLOBAL - default, gcp resources are globally-scoped when possible
   * SINGLE_REGION - gcp resources are replicated to specific regions, but still globally addressable
   * STRICT_REGIONAL - gcp resources are strictly region-locked, requiring regional api endpoint configuration
   *
   * @generated from field: optional string scope_type = 1;
   */
  scopeType?: string;
};

/**
 * Describes the message chalk.server.v1.GCPRegionConfig.
 * Use `create(GCPRegionConfigSchema)` to create a new message.
 */
export const GCPRegionConfigSchema: GenMessage<GCPRegionConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_cloud_config, 3);

/**
 * @generated from message chalk.server.v1.GCPSecretManagerConfig
 */
export type GCPSecretManagerConfig = Message<"chalk.server.v1.GCPSecretManagerConfig"> & {
  /**
   * @generated from field: optional string secret_region = 1;
   */
  secretRegion?: string;

  /**
   * the intention is that replicas should be empty unless the env
   * uses a user-managed replication policy with explicit regions
   *
   * @generated from field: repeated chalk.server.v1.GCPSecretReplicationReplica replicas = 2;
   */
  replicas: GCPSecretReplicationReplica[];
};

/**
 * Describes the message chalk.server.v1.GCPSecretManagerConfig.
 * Use `create(GCPSecretManagerConfigSchema)` to create a new message.
 */
export const GCPSecretManagerConfigSchema: GenMessage<GCPSecretManagerConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_cloud_config, 4);

/**
 * @generated from message chalk.server.v1.GCPWorkloadIdentity
 */
export type GCPWorkloadIdentity = Message<"chalk.server.v1.GCPWorkloadIdentity"> & {
  /**
   * @generated from field: string gcp_project_number = 1;
   */
  gcpProjectNumber: string;

  /**
   * @generated from field: string gcp_service_account = 2;
   */
  gcpServiceAccount: string;

  /**
   * @generated from field: string pool_id = 3;
   */
  poolId: string;

  /**
   * @generated from field: string provider_id = 4;
   */
  providerId: string;
};

/**
 * Describes the message chalk.server.v1.GCPWorkloadIdentity.
 * Use `create(GCPWorkloadIdentitySchema)` to create a new message.
 */
export const GCPWorkloadIdentitySchema: GenMessage<GCPWorkloadIdentity> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_cloud_config, 5);

/**
 * @generated from message chalk.server.v1.DockerBuildConfig
 */
export type DockerBuildConfig = Message<"chalk.server.v1.DockerBuildConfig"> & {
  /**
   * @generated from field: string builder = 1;
   */
  builder: string;

  /**
   * @generated from field: string push_registry_type = 2;
   */
  pushRegistryType: string;

  /**
   * @generated from field: string push_registry_tag_prefix = 3;
   */
  pushRegistryTagPrefix: string;

  /**
   * @generated from field: string registry_credentials_secret_id = 4;
   */
  registryCredentialsSecretId: string;

  /**
   * @generated from field: string notification_topic = 5;
   */
  notificationTopic: string;
};

/**
 * Describes the message chalk.server.v1.DockerBuildConfig.
 * Use `create(DockerBuildConfigSchema)` to create a new message.
 */
export const DockerBuildConfigSchema: GenMessage<DockerBuildConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_cloud_config, 6);

/**
 * @generated from message chalk.server.v1.ElasticsearchLogConfig
 */
export type ElasticsearchLogConfig = Message<"chalk.server.v1.ElasticsearchLogConfig"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string endpoint = 3;
   */
  endpoint: string;
};

/**
 * Describes the message chalk.server.v1.ElasticsearchLogConfig.
 * Use `create(ElasticsearchLogConfigSchema)` to create a new message.
 */
export const ElasticsearchLogConfigSchema: GenMessage<ElasticsearchLogConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_cloud_config, 7);

/**
 * @generated from message chalk.server.v1.AWSCloudConfig
 */
export type AWSCloudConfig = Message<"chalk.server.v1.AWSCloudConfig"> & {
  /**
   * @generated from field: string account_id = 1;
   */
  accountId: string;

  /**
   * @generated from field: string management_role_arn = 2;
   */
  managementRoleArn: string;

  /**
   * @generated from field: string region = 3;
   */
  region: string;

  /**
   * @generated from field: optional string external_id = 4;
   */
  externalId?: string;

  /**
   * @generated from field: chalk.server.v1.AWSCloudWatchConfig deprecated_cloud_watch_config = 5 [deprecated = true];
   * @deprecated
   */
  deprecatedCloudWatchConfig?: AWSCloudWatchConfig;

  /**
   * @generated from field: chalk.server.v1.AWSSecretManagerConfig deprecated_secret_manager_config = 6 [deprecated = true];
   * @deprecated
   */
  deprecatedSecretManagerConfig?: AWSSecretManagerConfig;

  /**
   * @generated from field: chalk.server.v1.GCPWorkloadIdentity workload_identity = 7 [deprecated = true];
   * @deprecated
   */
  workloadIdentity?: GCPWorkloadIdentity;

  /**
   * @generated from field: chalk.server.v1.DockerBuildConfig docker_build_config = 8;
   */
  dockerBuildConfig?: DockerBuildConfig;

  /**
   * @generated from field: chalk.server.v1.ElasticsearchLogConfig elasticsearch_log_config = 9;
   */
  elasticsearchLogConfig?: ElasticsearchLogConfig;

  /**
   * @generated from field: chalk.server.v1.AWSCloudWatchConfig cloudwatch_config = 10;
   */
  cloudwatchConfig?: AWSCloudWatchConfig;

  /**
   * @generated from field: chalk.server.v1.AWSSecretManagerConfig secretmanager_config = 11;
   */
  secretmanagerConfig?: AWSSecretManagerConfig;

  /**
   * @generated from field: chalk.server.v1.GCPWorkloadIdentity gcp_workload_identity = 12;
   */
  gcpWorkloadIdentity?: GCPWorkloadIdentity;

  /**
   * @generated from field: optional string permissions_boundary_arn = 13;
   */
  permissionsBoundaryArn?: string;
};

/**
 * Describes the message chalk.server.v1.AWSCloudConfig.
 * Use `create(AWSCloudConfigSchema)` to create a new message.
 */
export const AWSCloudConfigSchema: GenMessage<AWSCloudConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_cloud_config, 8);

/**
 * @generated from message chalk.server.v1.GCPCloudConfig
 */
export type GCPCloudConfig = Message<"chalk.server.v1.GCPCloudConfig"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string region = 2;
   */
  region: string;

  /**
   * Output only for cloud credentials. Caller-supplied values are deprecated and ignored;
   * the account is derived from the authenticated team and API server GCP project.
   *
   * @generated from field: optional string management_service_account = 3;
   */
  managementServiceAccount?: string;

  /**
   * @generated from field: chalk.server.v1.DockerBuildConfig docker_build_config = 4;
   */
  dockerBuildConfig?: DockerBuildConfig;

  /**
   * @generated from field: chalk.server.v1.GCPSecretManagerConfig secretmanager_config = 5;
   */
  secretmanagerConfig?: GCPSecretManagerConfig;

  /**
   * @generated from field: chalk.server.v1.GCPRegionConfig region_config = 6;
   */
  regionConfig?: GCPRegionConfig;
};

/**
 * Describes the message chalk.server.v1.GCPCloudConfig.
 * Use `create(GCPCloudConfigSchema)` to create a new message.
 */
export const GCPCloudConfigSchema: GenMessage<GCPCloudConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_cloud_config, 9);

/**
 * @generated from message chalk.server.v1.AzureContainerRegistryConfig
 */
export type AzureContainerRegistryConfig = Message<"chalk.server.v1.AzureContainerRegistryConfig"> & {
  /**
   * @generated from field: optional string registry_name = 1;
   */
  registryName?: string;
};

/**
 * Describes the message chalk.server.v1.AzureContainerRegistryConfig.
 * Use `create(AzureContainerRegistryConfigSchema)` to create a new message.
 */
export const AzureContainerRegistryConfigSchema: GenMessage<AzureContainerRegistryConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_cloud_config, 10);

/**
 * @generated from message chalk.server.v1.AzureKeyVaultConfig
 */
export type AzureKeyVaultConfig = Message<"chalk.server.v1.AzureKeyVaultConfig"> & {
  /**
   * @generated from field: optional string vault_name = 1;
   */
  vaultName?: string;
};

/**
 * Describes the message chalk.server.v1.AzureKeyVaultConfig.
 * Use `create(AzureKeyVaultConfigSchema)` to create a new message.
 */
export const AzureKeyVaultConfigSchema: GenMessage<AzureKeyVaultConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_cloud_config, 11);

/**
 * @generated from message chalk.server.v1.AzureCloudConfig
 */
export type AzureCloudConfig = Message<"chalk.server.v1.AzureCloudConfig"> & {
  /**
   * @generated from field: string subscription_id = 1;
   */
  subscriptionId: string;

  /**
   * @generated from field: string tenant_id = 2;
   */
  tenantId: string;

  /**
   * @generated from field: string region = 3;
   */
  region: string;

  /**
   * @generated from field: string resource_group = 4;
   */
  resourceGroup: string;

  /**
   * @generated from field: chalk.server.v1.DockerBuildConfig docker_build_config = 6;
   */
  dockerBuildConfig?: DockerBuildConfig;

  /**
   * @generated from field: chalk.server.v1.AzureContainerRegistryConfig container_registry_config = 7;
   */
  containerRegistryConfig?: AzureContainerRegistryConfig;

  /**
   * @generated from field: chalk.server.v1.AzureKeyVaultConfig key_vault_config = 8;
   */
  keyVaultConfig?: AzureKeyVaultConfig;

  /**
   * @generated from field: chalk.server.v1.GCPWorkloadIdentity gcp_workload_identity = 9;
   */
  gcpWorkloadIdentity?: GCPWorkloadIdentity;
};

/**
 * Describes the message chalk.server.v1.AzureCloudConfig.
 * Use `create(AzureCloudConfigSchema)` to create a new message.
 */
export const AzureCloudConfigSchema: GenMessage<AzureCloudConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_cloud_config, 12);

/**
 * LocalCloudConfig is intentionally empty. Local cluster, storage, registry, and
 * routing identity live in their existing component records; this message only
 * selects the local provider behavior.
 *
 * @generated from message chalk.server.v1.LocalCloudConfig
 */
export type LocalCloudConfig = Message<"chalk.server.v1.LocalCloudConfig"> & {
};

/**
 * Describes the message chalk.server.v1.LocalCloudConfig.
 * Use `create(LocalCloudConfigSchema)` to create a new message.
 */
export const LocalCloudConfigSchema: GenMessage<LocalCloudConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_cloud_config, 13);

/**
 * @generated from message chalk.server.v1.CloudConfig
 */
export type CloudConfig = Message<"chalk.server.v1.CloudConfig"> & {
  /**
   * @generated from oneof chalk.server.v1.CloudConfig.config
   */
  config: {
    /**
     * @generated from field: chalk.server.v1.AWSCloudConfig aws = 1;
     */
    value: AWSCloudConfig;
    case: "aws";
  } | {
    /**
     * @generated from field: chalk.server.v1.GCPCloudConfig gcp = 2;
     */
    value: GCPCloudConfig;
    case: "gcp";
  } | {
    /**
     * @generated from field: chalk.server.v1.AzureCloudConfig azure = 3;
     */
    value: AzureCloudConfig;
    case: "azure";
  } | {
    /**
     * @generated from field: chalk.server.v1.LocalCloudConfig local = 4;
     */
    value: LocalCloudConfig;
    case: "local";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.server.v1.CloudConfig.
 * Use `create(CloudConfigSchema)` to create a new message.
 */
export const CloudConfigSchema: GenMessage<CloudConfig> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_cloud_config, 14);

